import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { clsx } from "clsx";
import styles from "./HeaderButton.module.scss";
import { ComponentPropsWithRef, forwardRef, Ref } from "react";
import { HeaderTheme } from "./types.ts";

type HeaderButtonProps = ComponentPropsWithRef<typeof BaseLinkOrButton> & {
  theme?: HeaderTheme;
};

function HeaderButton(
  { theme, className, ...rest }: HeaderButtonProps,
  ref: Ref<HTMLButtonElement | HTMLAnchorElement>
) {
  return (
    <BaseLinkOrButton
      ref={ref}
      className={clsx(
        className,
        "vst-button-rectangle",
        "vst-button-variant-frost",
        "vst-button-size-large",
        styles.button,
        theme === "accent" && styles.accent,
        theme === "outline" && styles.outline
      )}
      {...rest}
    />
  );
}

const ForwardRef = forwardRef(HeaderButton);
export default ForwardRef;
